export default "__VITE_ASSET__oDNXShOA__"